/**
 * Created by shamim.ahsan on 10/24/2018.
 */
import { Configuration } from '@shared/models/configuration';
import {ParticleConfig} from '../particle-config';


// @dynamic
export class TreatyConfig {
  static get TreatyAPI(): string {
    return Configuration.getConfig('TreatyApi');
  }
  static getAll() {
    return `${TreatyConfig.TreatyAPI}Entity/GetByPage?pageNo=0&pageSize=10000&projectId=[PROJECT_ID]`;
  }
  public static downloadEventAPI(): string {
    return `${ParticleConfig.TreatyApi}Treaty/DownloadEvent`;
  }
}



